import React, { useContext, useEffect, useState } from 'react';
import { shape, oneOf } from 'prop-types';

import helper from '../../utils/helper';
import { ReservationContext } from '../../context/reservation-context';
import { militaryToShortStandardTime } from '../../utils/mapper';

import './store-hours.scss';

export const StoreHours = ({ store, padding }) => {
  const [pickupOpenHour, setPickupOpenHour] = useState('');
  const [pickupCloseHour, setPickupCloseHour] = useState('');
  const [dropoffOpenHour, setDropoffOpenHour] = useState('');
  const [dropoffStoreHour, setDropoffCloseHour] = useState('');

  const [reservationState, _dispatch] = useContext(ReservationContext); // NOSONAR

  useEffect(() => {
    const pickupHours = helper.getRentalOrStoreHours(store, 'pickup', reservationState?.reservation?.pickupDate);
    setPickupOpenHour(militaryToShortStandardTime(pickupHours.open));
    setPickupCloseHour(militaryToShortStandardTime(pickupHours.close));
    const dropoffHours = helper.getRentalOrStoreHours(store, 'dropoff', reservationState?.reservation?.dropoffDate);
    setDropoffOpenHour(militaryToShortStandardTime(dropoffHours.open));
    setDropoffCloseHour(militaryToShortStandardTime(dropoffHours.close));
  }, []);

  if (store?.rentalHours?.weeklyHours) {
    const weekdayHours = store?.rentalHours?.weeklyHours.monday;
    const weekdayOpen = militaryToShortStandardTime(weekdayHours.open);
    const weekdayClose = militaryToShortStandardTime(weekdayHours.close);
    const sundayHours = store?.rentalHours?.weeklyHours.sunday;
    const sundayOpen = militaryToShortStandardTime(sundayHours.open);
    const sundayClose = militaryToShortStandardTime(sundayHours.close);

    return (
      <div className={`store-hours padding-${padding}`} data-testid="store-hours">
        <div className="line">
          <div className="hours-copy title">Mon-Sat: &nbsp;</div>
          <div className="hours-copy">{weekdayOpen} - {weekdayClose}</div>
        </div>
        <div className="line">
          <div className="hours-copy title">Sun: &nbsp;</div>
          <div className="hours-copy">{sundayOpen} - {sundayClose}</div>
        </div>
      </div>
    );
  }
  return (
    <div className="store-hours">
      <div className="line">
        <div className="hours-copy title">Pickup: &nbsp;</div>
        <div className="hours-copy">{pickupOpenHour} - {pickupCloseHour}</div>
      </div>
      <div className="line">
        <div className="hours-copy title">Dropoff: &nbsp;</div>
        <div className="hours-copy">{dropoffOpenHour} - {dropoffStoreHour}</div>
      </div>
    </div>
  );

};

StoreHours.propTypes = {
  store: shape({}).isRequired,
  padding: oneOf(['large', 'small'])
};
StoreHours.defaultProps = {
  padding: 'large'
};
